export const default_state = {
	app: {
		theme: "dark",
		userName: "",
		name: "",
		userData: null,
		repoData: null,
		userActivity: null,
		commitHistory: null,
		week_dict: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	},
};
